import UbigeoView from '../UbigeoView.vue'
import DepartmentList from '../Pages/DepartmentList.vue'
import ProvinceList from '../Pages/ProvinceList.vue'
import DistrictList from '../Pages/DistrictList.vue'
import UbigeoSearch from '../Pages/UbigeoSearch.vue'

const routes = [
  {
    path: '/ubigeo',
    component: UbigeoView,
    children: [
      { path: '', redirect: { name: 'ubigeo-departamentos' } },
      {
        path: 'departamentos',
        name: 'ubigeo-departamentos',
        component: DepartmentList
      },
      {
        path: 'departamentos/:dept/provincias',
        name: 'ubigeo-provincias',
        component: ProvinceList
      },
      {
        path: 'departamentos/:dept/provincias/:prov/distritos',
        name: 'ubigeo-distritos',
        component: DistrictList
      },
      {
        path: 'search',
        name: 'ubigeo-search',
        component: UbigeoSearch
      }
    ]
  }
]

export default routes
